<template>

  <b-form class="row searchContainer">

    <b-form-group>
      <base-select class="searchSpeciality" id="specialities" v-model="selectSpeciality.selected" :label="$i18nHelpers.normalizeProp('name')" placeholder='Especialidad' valueProp="id" :options="selectSpeciality.options"></base-select>
      <b-form-invalid-feedback>{{ $t('signupOH.errors.enterCountry') }}</b-form-invalid-feedback>
    </b-form-group> 

    <b-form-group>
      <base-select class="searchConsultationType" id="services" v-model="selectConsultation.selected" label="text" placeholder="Servicios" :options="selectConsultation.options"></base-select>
      <b-form-invalid-feedback>{{ $t('signupOH.errors.enterCountry') }}</b-form-invalid-feedback>
    </b-form-group>

    <b-form-group class="searchOHDiv">
      <b-button class="searchButton" type="submit" variant="primary" ><base-icon class="arrowImage" :color="WHITE_COLOUR"  src="/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg"></base-icon></b-button>
    </b-form-group>

  </b-form>

</template>

<script>
import { BForm, BFormGroup, BButton, BFormInvalidFeedback, BFormInput, BAlert } from 'bootstrap-vue'
import { WHITE_COLOUR } from '@/constants/colours'
import BaseIcon from '../../base/icons/BaseIcon.vue'

export default {
  components: {
    BForm,
    BFormGroup,
    BButton,
    BFormInvalidFeedback,
    BFormInput,
    BAlert,
    'base-select': () => import('@/components/base/forms/BaseSelect'),
    'base-multiSelect': () => import('@/components/base/forms/BaseMultiSelect'),
    'binary-radio-group': () => import('@/components/base/forms/RadioButtonGender'),
    BaseIcon
  },
  props: {
    loginUrl: {
      type: String,
      required: false
    },
    loginCallback: {
      type: Function,
      required: false
    }
  },
  data () {
    return {
      WHITE_COLOUR,
      form: {
        email: null,
        password: null,
        csrfToken: null,
        state: {
          waiting: false,
          unauthorized: false,
          errors: false,
          submitted: false
        }
      },
      formSelectLang: {
        selected: null,
        options: [
          { value: '1', text: 'Español' },
          { value: '2', text: 'English' },
          { value: '4', text: 'Français' },
          { value: '5', text: 'Deutsch' },
          { value: '7', text: 'Català' },
          { value: '3', text: 'Italiano' },
          { value: '6', text: 'Portugués' },
          { value: '8', text: 'Galego' },
          { value: '9', text: 'Euskara' },
          { value: '10', text: 'русский язык' },
          { value: '11', text: '漢語' },
          { value: '12', text: 'Valencià' },
          { value: '13', text: 'العربية' },
          { value: '14', text: 'Български език' },
          { value: '15', text: 'Čeština' },
          { value: '16', text: 'Dansk' },
          { value: '17', text: 'Slovenčina' },
          { value: '18', text: 'Slovenščina' },
          { value: '19', text: 'Eesti keel' },
          { value: '20', text: 'Suomen kieli' },
          { value: '21', text: 'Ελληνική γλώσσα' },
          { value: '22', text: 'Magyar nyelv' },
          { value: '23', text: 'Gaeilge' },
          { value: '24', text: 'Latviešu valoda' },
          { value: '25', text: 'Lietuvių kalba' },
          { value: '26', text: 'Il-Malti' },
          { value: '27', text: 'Nederlands' },
          { value: '28', text: 'Polski' },
          { value: '29', text: 'Limba română' },
          { value: '30', text: 'Hrvatski jezik' },
          { value: '31', text: 'Svenska' }
        ]
      },
      binRadioGroup: {
        selected: null
      },
      selectSpeciality: {
        selected: null,
        options: []
        /* options: [
          { value: 1, text: 'Videoconsulta Inmediata' },
          { value: 4, text: 'Videoconsulta Programada' },
          { value: 5, text: 'Consulta Escrita' },
          { value: 10, text: 'Chat' },
          { value: 11, text: 'El profesional te llama' },
          { value: 2, text: 'Consulta Presencial' },
          { value: 7, text: 'Segunda Opinión' }
        ] */
      },
    selectConsultation: {
        selected: null,
        options: [
          { value: 52, text: 'Pediatría' },
          { value: 56, text: 'Psiquiatría' },
          { value: 'a', text: 'Otra' },
          { value: 'b', text: 'Otra' },
          { value: 'c', text: 'Otra' },
          { value: 'd', text: 'Otra' }
        ]
      },
      selectProvince: {
        selected: null,
        options: [
          { value: '651', text: 'Sevilla' },
          { value: 'a', text: 'Otra' },
          { value: 'b', text: 'Otra' },
          { value: 'c', text: 'Otra' },
          { value: 'd', text: 'Otra' }
        ]
      },
      selectPrefix: {
        selected: null,
        options: [
          { value: '28', text: 'España (+34)' },
          { value: 'a', text: 'Otra' },
          { value: 'b', text: 'Otra' },
          { value: 'c', text: 'Otra' },
          { value: 'd', text: 'Otra' }
        ]
      },
      errors: {
        email: null,
        password: null
      },
      submitError: null
    }
  },
  methods: {
    signup: function () {
      const _this = this
      this.resetForm()
      this.form.state.submitted = true
      this.form.state.waiting = true
      if (this.formValid !== false) {
        this.$api.post(this.loginUrl, {
          companyCode: _this.form.companyCode.trim(),
          languages: _this.formSelectLang.selected.trim(),
          name: _this.form.name.trim()
        }).then((response) => {
          this.loginCallback ? this.loginCallback(response) : this.defaultLoginCallback(response)
        }).catch(function () {
          _this.form.state.errors = true
          _this.form.state.waiting = false
        })
      } else {
        _this.form.state.waiting = false
      }
    },
    defaultLoginCallback (response) {
      if (response.data) {
        switch (response.data.code) {
          case 200:
            window.location = response.data.url
            break
          case 403:
            this.submitError = response.data.message
            this.form.state.unauthorized = true
            this.form.state.waiting = false
            break
          default:
            this.form.state.errors = true
            this.form.state.waiting = false
            break
        }
      } else {
        this.form.state.errors = true
        this.form.state.waiting = false
      }
    },
    resetForm: function () {
      this.form.state.submitted = false
      this.form.state.waiting = false
      this.form.state.unauthorized = false
      this.form.state.errors = false
    }
  },
  computed: {
    formValid: function () {
      return this.emailValidation && this.passwordValidation
    },
    emailValidation: function () {
      return this.$validators.validate(this.form.email, ['required', 'email'], this.form.state.submitted)
    },
    passwordValidation: function () {
      return this.$validators.validate(this.form.password, ['required'], this.form.state.submitted)
    }
  },
  mounted () {
    // Retrieve specialties from api and load on specialties select
    this.$api.get('specialties').then((response) => {
      this.selectSpeciality.options = response.data
    })
  }
}
</script>

<style lang="scss">

    .searchContainer{
        width: 60vw !important;
        text-align: left;
        display: inline;
        margin-top: -14%;
        margin-left: 0px !important;
    }

    .searchArrow{
      height: 50%;
      margin: 34% 0% 0% 0% !important;
    }

    .searchSubmit{
      display: contents;
    }

    .vs__search{
      width: auto !important;
    }

    .searchButton{
      height: 37px;
    }

    .searchOHDiv{
      padding-top: 8px;
    }

</style>



// WEBPACK FOOTER //
// src/components/layouts/patient/SearchTab.vue